import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function BrandLogo() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {/* Logo image placeholder - replace with actual logo */}
      {/* To use: add logo.svg or logo.png to /public folder and update src below */}
      <Box
        component="img"
        src="/logo.svg"
        alt="OpenIntake"
        sx={{
          height: 32,
          mr: 1,
          display: 'block',
        }}
        onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
          // Hide image if not found
          e.currentTarget.style.display = 'none';
        }}
      />
      {/* Fallback text logo */}
      <Typography
        sx={{
          fontFamily: '"Manrope", sans-serif',
          fontSize: '1.25rem',
          fontWeight: 400,
          color: '#3E301E',
          letterSpacing: '-0.5px',
        }}
      >
        Open<span style={{ fontWeight: 800 }}>Intake</span>
      </Typography>
    </Box>
  );
}
